import { render, staticRenderFns } from "./sendFlowDialog.vue?vue&type=template&id=08c3cc24&scoped=true&"
import script from "./sendFlowDialog.vue?vue&type=script&lang=js&"
export * from "./sendFlowDialog.vue?vue&type=script&lang=js&"
import style0 from "./sendFlowDialog.vue?vue&type=style&index=0&id=08c3cc24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c3cc24",
  null
  
)

component.options.__file = "output/sendFlowDialog.vue"
export default component.exports